import React from 'react'
import {isObject, isFunction, keys, pick, uniq} from 'lodash'
import {qs} from '../util'
import {withQueryParams} from './with-query-params'

const withNavigation = (Component) => {
  return withQueryParams((props) => {
    const {navigate: originalNavigate, location} = props
    if (isFunction(originalNavigate) && location) {
      const navigate = async function () {
        let args = Array.from(arguments)
        let options = {}
        if (args.length === 2 && isObject(args[1])) {
          options = args[args.length - 1]
        }
        let {query = {}} = props
        let {
          query: newQueryParams,
          forwardQueryParams = [],
          includeReturnPath = false
        } = options
        if (forwardQueryParams === true) {
          forwardQueryParams = keys(query)
        }
        if (includeReturnPath) {
          forwardQueryParams = uniq([...forwardQueryParams, 'returnPath'])
          newQueryParams = {...newQueryParams, returnPath: location.pathname+location.search}
        }
        query = {...pick(query, forwardQueryParams), ...newQueryParams}
        if (args.length > 0) {
          const [url] = args[0].split('?')
          args[0] = `${url}${qs(query)}`
        }
        if (args.length === 2) {
          args[1] = options
        }
        return originalNavigate.apply(this, args)
      }
      props = {...props, navigate}
    }
    return <Component {...props}/>
  })
}

export {withNavigation}

export default withNavigation